module.exports = __webpack_public_path__ + "img/cyngn.67957627.png";